import { useAbility } from '../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../constants/permissions';
import { cvApi } from '../services/api/cvApi';

/**
 * Custom hook that provides CV permission checking functions
 * @returns {Object} Object containing permission checking functions
 */
export const useCVPermissions = () => {
  const ability = useAbility();

  /**
   * Check if user can manage a CV
   * @param {Object} cv - The CV object to check permissions for
   * @returns {Promise<boolean>} True if user can manage the CV
   */
  const canManageCV = async (cv) => {
    if (!cv) {
      return false;
    }

    // Check if CV has an employee linked
    if (!cv.employee) {
      // For unlinked CVs, check general CV management permission
      return ability.can(ACTIONS.MANAGE, SUBJECTS.CV);
    }

    // For linked CVs, use the API to check access
    try {
      const response = await cvApi.canAccessCV(cv.employee.id);
      return response.canAccess;
    } catch (error) {
      // If API call fails, default to no access
      console.error('Error checking CV access:', error);
      return false;
    }
  };

  return {
    canManageCV
  };
};
